import { render, staticRenderFns } from "./confirmDialog.vue?vue&type=template&id=5b83fa96&scoped=true&"
import script from "./confirmDialog.vue?vue&type=script&lang=ts&"
export * from "./confirmDialog.vue?vue&type=script&lang=ts&"
import style0 from "./confirmDialog.vue?vue&type=style&index=0&id=5b83fa96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83fa96",
  null
  
)

export default component.exports